<nav-bar [navBarItems]="periodosNavBar" [initialValue]="+periodosNavBar[0].value" [placeholder]="'Seleccione un año'"
         [navOnChange]="true"></nav-bar>
<div class="container__table">
    <h4>Nivelaciones</h4>
    <ng-container *ngIf="dataSource; else loading">
        <div class="flex-wrap">
            <mat-form-field>
                <input matInput (keyup)="filtroTexto($event.target.value)" placeholder="Filtro de texto">
            </mat-form-field>
            <span class="spacer"></span>
            <nivelaciones-convenciones [asistencia]="true"></nivelaciones-convenciones>
        </div>
        <mat-table #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="Curso">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> Curso</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    <a [routerLink]="['/nivelaciones/reportes/director-curso/'+element.materia.cursoID]">
                        {{element.materia.cursoNickName}}
                    </a>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Materia">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__longest'"> Materia</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__longest'">
                    <a [routerLink]="['/nivelaciones/materia/' + element.materia.id + '/mes/' + mesEnCurso]">
                        {{element.materia.nombreCompleto}}
                    </a>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Profesor">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__longest'"> Profesor</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__longest'">
                    <ul>
                        <li *ngFor="let profesor of element.profesores">
                            {{profesor.nombresApellidos}}
                        </li>
                    </ul>
                    {{element.nombre}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Citaciones">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__longest'"> Citaciones</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__longest'">
                    <div class="flex-wrap">
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.ausentes !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesAusente
                                     hidden>
                                    <ul>
                                        <li *ngFor="let detalleAusentes of element.ausentesDetalle">
                                            {{detalleAusentes.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleAusentes.fechaCorta}}
                                            </div>
                                            <div>
                                                {{detalleAusentes.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo error cursor-pointer" (click)="toggleDetalles(detallesAusente)">
                                    {{element.ausentes}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.retardos !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesRetardo
                                     hidden>
                                    <ul>
                                        <li *ngFor="let detalleRetardos of element.retardosDetalle">

                                            {{detalleRetardos.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleRetardos.fechaCorta}}
                                            </div>
                                            <div>{{detalleRetardos.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo warn cursor-pointer" (click)="toggleDetalles(detallesRetardo)">
                                    {{element.retardos}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.presentes !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesPresente
                                     hidden>
                                    <ul>
                                        <li *ngFor="let detallePresentes of element.presentesDetalle">

                                            {{detallePresentes.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detallePresentes.fechaCorta}}
                                            </div>
                                            <div>{{detallePresentes.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo success cursor-pointer" (click)="toggleDetalles(detallesPresente)">
                                    {{element.presentes}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.noReportaAsistencia !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesNoReporta
                                     hidden>
                                    <ul>
                                        <li *ngFor="let detalleNoReporta of element.noReportaAsistenciaDetalle">

                                            {{detalleNoReporta.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleNoReporta.fechaCorta}}
                                            </div>
                                            <div> {{detalleNoReporta.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo neutral cursor-pointer"
                                      (click)="toggleDetalles(detallesNoReporta)">
                                    {{element.noReportaAsistencia}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.futuras !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesFuturas
                                     hidden>
                                    <ul>
                                        <li *ngFor="let detalleFuturas of element.futurasDetalle">

                                            {{detalleFuturas.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleFuturas.fechaCorta}}
                                            </div>
                                            <div> {{detalleFuturas.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo cursor-pointer" (click)="toggleDetalles(detallesFuturas)">
                                    {{element.futuras}}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Total">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> Total</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.totalCitados}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="S">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> S</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.nota1}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="A">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> A</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.nota2}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="B">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> B</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.nota3}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="D">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> D</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.nota4}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="I">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> I</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.nota5}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="NA">
                <mat-header-cell *matHeaderCellDef [ngClass]="'cell__short'"> N.A.</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'cell__short'">
                    {{element.notasAcumuladas.reprobados}}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;">
            </mat-row>
        </mat-table>
    </ng-container>
    <ng-template #loading>
        <mat-spinner [mode]="'indeterminate'"></mat-spinner>
    </ng-template>
</div>